import * as types from "../../types"

const initialState = {
  list: []
}

export default function authListReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case types.UPDATE_AUTH_LIST: {
      return {
        ...payload
      }
    }
    default:
      return state
  }
}
